// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
Vue.config.devtools = true;
import Vue from 'vue'
import i18n from '../../lang/index'
import router from '../../router'
import ElementUI from 'element-ui'
import Vuex from 'vuex'
import App from './index.vue'
import 'element-ui/lib/theme-chalk/index.css'
import '@/common/css/icon/iconfont.css'
import '@/common/css/common.css'
import '@/components'
import libs from './../../libs/index.js'
import store from '../../store/index'
import 'babel-polyfill'

Vue.use(libs)
Vue.use(ElementUI)
Vue.use(Vuex)
if (Number.parseInt === undefined) Number.parseInt = window.parseInt
if (Number.parseFloat === undefined) Number.parseFloat = window.parseFloat
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    components: { App },
    el: '#app',
    router,
    store,
    i18n,
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/pages/index/index.js